import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

// Signature gold-to-rose gradient pill CTA with glow + scale micro-interaction.
export const GoldButton = React.forwardRef(
  ({ children, className = "", size = "md", icon: Icon, ...props }, ref) => {
    const sizes = {
      sm: "px-5 py-2.5 text-sm",
      md: "px-7 py-3.5 text-[15px]",
      lg: "px-9 py-4 text-base",
    };
    return (
      <motion.button
        ref={ref}
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.97 }}
        transition={{ type: "spring", stiffness: 400, damping: 22 }}
        className={cn(
          "group relative inline-flex items-center justify-center gap-2 rounded-full font-display font-semibold tracking-wide text-charcoal-deep",
          "bg-gradient-to-r from-gold via-gold-amber to-gold-rose",
          "shadow-[0_8px_24px_-6px_rgba(212,175,55,0.5)] hover:shadow-[0_0_32px_rgba(232,180,92,0.55)]",
          "transition-shadow duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/70 focus-visible:ring-offset-2 focus-visible:ring-offset-ivory",
          sizes[size],
          className
        )}
        {...props}
      >
        {children}
        {Icon && <Icon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />}
      </motion.button>
    );
  }
);
GoldButton.displayName = "GoldButton";

export const GhostButton = React.forwardRef(({ children, className = "", ...props }, ref) => (
  <button
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center gap-2 rounded-full border border-charcoal/15 bg-white/50 px-7 py-3.5 text-[15px] font-medium text-charcoal backdrop-blur-sm",
      "transition-colors duration-300 hover:border-gold/50 hover:bg-white/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/70",
      className
    )}
    {...props}
  >
    {children}
  </button>
));
GhostButton.displayName = "GhostButton";
